/**
 * Project panel
 * formatDate.js
 * Created by stefensuhat on 2019-01-17 21:57
 */


import format from 'date-fns/format';
import isDate from 'date-fns/isDate';
import parseISO from 'date-fns/parseISO';

export default function (date, formatStr) {
    if (!date) {
        return '';
    }

    if (isDate(date)) {
        return format(date, formatStr);
    }

    return format(parseISO(date), formatStr);
}
